import { ResponsiveDataTable } from '@/ui/organisms/responsive-data-table/ResponsiveDataTable'
import { UserPoints } from '@/domain/merkl/types'
import { Typography } from '@/ui/atoms/typography/Typography'
interface Props {
  weeklyPoints?: UserPoints['finishedWeeksPoints']
}

export function WeeklyTable({ weeklyPoints }: Props) {
  return (
    <div className="flex w-full flex-col gap-4">
      <ResponsiveDataTable
        gridTemplateColumnsClassName="grid-cols-[3fr_1fr]"
        columnDefinition={{
          week: {
            header: <div className="flex items-center gap-2">Epoch</div>,
            headerAlign: 'left',
            showOnMobile: true,
            renderCell: ({ epochNumber, formattedStartTimestamp, formattedEndTimestamp }) => {
              const startDate = formattedStartTimestamp ? formattedStartTimestamp : undefined
              const endDate = formattedEndTimestamp ? formattedEndTimestamp : undefined

              return (
                <div>
                  <div className="flex w-full flex-col items-baseline gap-2 text-sm sm:flex-row">
                    <span className="inline-block w-20">{epochNumber === 29 ? 'Founder' : `Epoch ${epochNumber}`}</span>
                    {startDate && (
                      <Typography variant="prompt" className="font-mono">
                        {epochNumber === 29 ? startDate : endDate ? `${startDate} - ${endDate}` : startDate}
                      </Typography>
                    )}
                  </div>
                </div>
              )
            },
          },
          points: {
            header: <div className="w-full text-right">Running Total</div>,
            headerAlign: 'right',
            showOnMobile: true,
            renderCell: ({ weeklySum }) => (
              <div className="flex h-full items-center justify-end">
                <Typography variant="p" gradient className="font-bold text-sm">
                  <span>
                    {Number(weeklySum).toLocaleString(undefined, {
                      minimumFractionDigits: weeklySum.eq(0) ? 0 : 2,
                      maximumFractionDigits: 2,
                    })}
                  </span>
                </Typography>
              </div>
            ),
          },
        }}
        data={weeklyPoints || []}
      />
    </div>
  )
}
